<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyleHead(index)">
                            <CRow class="no-gutters">
                                <CCol sm="11">
                                    <span>{{item}}</span>
                                </CCol>
                                <CCol sm="1">
                                    <img :src="sortIcon[index]" width="8px" height="16px" style="float:right"/>
                                </CCol>
                            </CRow>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            {{body[item]}}
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit mr-1">Edit</CButton>
                                            <CButton @click="goDelete(id)" class="btn btn-delete">Delete</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <CRow class="no-gutters">
                                        <CCol sm="11">
                                            <span>{{item}}</span>
                                        </CCol>
                                        <CCol sm="1">
                                            <img :src="sortIcon[index]" width="8px" height="16px" style="float:right"/>
                                        </CCol>
                                    </CRow>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action'">
                                        {{body[item]}}
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit mr-1">Edit</CButton>
                                            <CButton @click="goDelete(id)" class="btn btn-delete">Delete</CButton>
                                        </template>
                                    </td>
                                </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        goDelete(id) {
            this.$emit('delete', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        loadStyleHead(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] 
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },    
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 8px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 8px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
.wrap {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-delete {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-delete:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: red;
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
</style>